<template>
    <div class="my-projects">
        <input type="hidden" v-model="reseter.counter">
          <projects-filter :status="this.filters.status" :disabled="isLoading" @filter="filter_project" @loaded="handleLoadedFilters($event)"></projects-filter>

        <div class="table-responsive projects-wrap" v-if="detail">
          <base-table class="table align-items-center table-flush projects-table"
                      :class="type === 'dark' ? 'table-dark': ''"
                      :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                      tbody-classes="list"
                      :data="projects">
            <template slot="columns">
              <th>Case #</th>
              <th>Date</th>
              <th>Project Name</th>
              <th>City</th>
              <th>State</th>
              <th>Est. Start</th>
              <th>Status</th>
              <th></th>
            </template>

            <template slot-scope="{row}">
              <td>{{ row.quote_number }}</td>
              <td>{{ row.updated_at.split(' ')[0] }}<br>{{ row.updated_at.split(' ')[1] }}</td>
              <th scope="row">{{ row.project_name }}</th>
              <td>{{ row.city }}</td>
              <td>{{ row.state }}</td>
              <td>{{ row.start_date }}</td>
              <td>
                <badge class="badge-dot mr-4" :type="row.status.toLowerCase()">
                  <i :class="`bg-${row.status.toLowerCase()}`"></i>
                  <span class="status">{{row.status.toLowerCase()}}</span>
                </badge>
              </td>
              <td>
                <base-button type="primary" size="sm" @click="getDetail(row.id)">
                  <span v-if="isDLoading == row.id">Loading...</span>
                  <span v-else>View Details</span>
              </base-button></td>
            </template>

          </base-table>
          <div class="projects-list">
              <div v-if="isLoading">Loading...</div>
              <div v-else-if="!projects.length">No Projects Found</div>
          </div>
        </div>

        <div class="table-responsive">
            <div class="list-proj" id="list-proj" @scroll="scrollProj">
                <div class="row list-head">
                    <template v-if="(user.role == 'super_admin' || user.role == 'administrator') && ['YES','NO'].includes(filters.pending_close)">
                        <div class="col sort-false col-check-th"><input type="checkbox" v-model="default_select_all_project" @change="select_all_projects"></div>
                    </template>
                    <div class="col col-proj-caseno" data-key="quote_number" @click="sort_list">Case #</div>
                    <div class="col col-proj-date" data-key="updated_at" @click="sort_list">Date</div>
                    <div class="col col-proj-job" data-key="project_name" @click="sort_list">Job Name</div>
                    <template v-if="user.role == 'ses-view'">
                        <div class="col col-proj-company" data-key="company_name" @click="sort_list">Company</div>
                    </template>
                    <template v-if="user.role && (user.role == 'super_admin' || user.role == 'administrator' || user.role == 'project-manager' || user.role == 'super-user' || user.role.indexOf('ses-') != -1)">
                        <div class="col col-proj-sub" data-key="username" @click="sort_list">Subsidiary</div>
                        <div class="col col-proj-sub" data-key="territory" @click="sort_list">Territory</div>
                    </template>
                    <template v-if="user.role == 'super_admin' || user.role == 'administrator'">
                        <div class="col col-proj-region" data-key="managers" @click="sort_list">Region</div>
                    </template>
                    <div class="col col-proj-city" data-key="city" @click="sort_list">City</div>
                    <div class="col col-proj-state" data-key="state" @click="sort_list">State</div>
                    <div class="col col-proj-start" data-key="start_date" @click="sort_list">Est. Start</div>
                    <div class="col col-proj-total" data-key="total_price" @click="sort_list">Total</div>
                </div>

                <div class="list-row" v-for="(row,ri) in projects" :key="row.id">
                    <div class="row list-data" :data-row="ri">
                        <template v-if="(user.role == 'super_admin' || user.role == 'administrator') && ['YES','NO'].includes(filters.pending_close)">
                            <div class="col col-check-td"><input type="checkbox" :checked="selected_projects.indexOf(row.id) != -1" @change="select_project($event, row.id)"></div>
                        </template>
                        <div class="col col-proj-caseno">{{ row.quote_number }}{{ (row.revision === 'A' || row.revision === '') ? '' : `-${row.revision}` }}</div>
                        <div class="col col-proj-date">{{ row.updated_at.split(' ')[0] }} {{ row.updated_at.split(' ')[1] }}</div>
                        <div class="col col-proj-job break-word" scope="row">{{ row.project_name }}</div>
                        <template v-if="user.role == 'ses-view'">
                            <div class="col col-proj-company break-word">{{ user.id == row.customer_id ? user.company : getCompany(row.customer_id) }}</div>
                        </template>
                        <template v-if="user.role && (user.role == 'super_admin' || user.role == 'administrator' || user.role == 'project-manager' || user.role == 'super-user' || user.role.indexOf('ses-') != -1)">
                            <div class="col col-proj-sub break-word">{{ user.id == row.customer_id ? user.company : getSubsidiary(row.customer_id) }}</div>
                            <div class="col col-proj-sub break-word">{{ row.territory }}</div>
                        </template>
                        <template v-if="user.role == 'super_admin' || user.role == 'administrator'">
                            <div class="col col-proj-region break-word">{{ getRegion(row.customer_id) }}</div>
                        </template>
                        <div class="col col-proj-city break-word">{{ row.city }}</div>
                        <div class="col col-proj-state break-word">{{ row.state }}</div>
                        <div class="col col-proj-start">{{ row.start_date }}</div>
                        <div class="col col-proj-total text-right">
                            <template v-if="row.drawing_status == 'generating' || row.drawing_status == 'waiting' || row.drawing_status == 'processing'">
                                <template v-if="row.status == 'CLOSED'">0.00</template>
                                <template v-else>pending</template>
                            </template>
                            <template v-else-if="row.status == 'CLOSED' || row.status.toUpperCase() == 'CUSTOM'">0.00</template>
                            <template v-else-if="user.role == 'super-user' && ['INITIAL','FINAL'].includes(row.status)">
                                <span class="price-info">$ {{ formatPrice(row.total_price) }}</span>
                                <span class="price-update">
                                    <a class="price-btn" @click="priceUpdate(row.id)">
                                        <em v-if="!isPriceUpdating || toPriceUpdateID !== row.id" style="font-style: normal; color: red"> UPDATE</em>
                                        <em v-else-if="isPriceUpdating && toPriceUpdateID === row.id" style="font-style: normal; color: red"> UPDATING...</em>
                                    </a>
                                </span>
                            </template>
                            <template v-else>$ {{ formatPrice(row.total_price) }}</template>
                        </div>
                    </div>
                    <div class="row list-action">
                        <div class="col-md-12 action-wrap">
                            <div class="action-status">
                                <small class="ses-phase" v-if="row.phase == 'construction'">CONSTRUCTION</small>
                                <badge class="badge-dot mr-4" :type="row.status.toLowerCase()">
                                    <span class="status" v-if="row.status == 'CUSTOM'">CUSTOM-{{row.is_final=='yes'?'F':'I'}}</span>
                                    <span class="status" v-else>{{ row.status.toLowerCase()}}</span>
                                </badge>
                                <template v-if="user.role == 'super_admin' || user.role == 'administrator'">
                                    <badge v-if="row.delivery_status" class="badge-dot badge-delivered mr-4" :type="'delivered-' + row.delivery_status.toLowerCase().replace(/[^a-z0-9]+/g, '-')">
                                        <span class="status" >{{row.delivery_status + (row.eta_final_des ? (' - ETA: ' + row.eta_final_des) : '')}}</span>
                                    </badge>
                                </template>
                                <span class="ses-sonum" v-if="row.so_number" v-html="row.so_number.replaceAll(',','<br>')">{{ row.so_number }}</span>
                                <template v-if="user.role == 'super_admin' || user.role == 'administrator'">
                                    <badge v-if="row.pending_close == 'Yes' && row.status != 'CLOSED'" class="badge-dot mr-2" type="pending-close">
                                        <span class="status">Pending Close</span>
                                    </badge>
                                    <badge v-if="row.response_code" class="badge-dot mr-2" type="response-code">
                                        <span class="status">{{ row.response_code }}</span>
                                    </badge>
                                </template>
                                <template v-if="user.role == 'super-user'">
                                    <template v-if="(row.status.toUpperCase() == 'FINAL' || row.status == 'VERIFIED') && row.drawing_status != 'generating' && row.drawing_status != 'waiting' && row.drawing_status != 'processing'">
                                        <a class="action action-green" v-if="row.status == 'VERIFIED'" @click="purchase(row)"><span>$</span> Purchase</a>
                                        <a class="action action-green" v-else @click="verify(row)"><span>$</span> Verify</a>
                                    </template>
                                    <a :class="{ 'action action-blue action-center': row.response_code === '' || !row.response_code }" style="line-height: 16px; text-decoration: none" @click="handleResponse(row)">
                                        <em v-if="row.response_code === '' || !row.response_code" style="font-style: normal"> Note</em>
                                        <em v-else style="font-style: normal">{{ row.response_code }}</em>
                                    </a>
                                    <a v-if="row.close_reason && row.status == 'CLOSED'" @click="goAlert(row.close_reason)">Reason</a>
                                </template>
                                <template v-else-if="user.role != 'Field' && user.role != 'super-user'">
                                    <template v-if="(row.status.toUpperCase() == 'FINAL' || row.status == 'REQUESTED' || row.status == 'VERIFIED') && user.can_purchase && row.drawing_status != 'generating' && row.drawing_status != 'waiting' && row.drawing_status != 'processing'">
                                        <template v-if="user.role == 'distributor'">
                                            <a class="action action-green" v-if="row.status == 'REQUESTED' || row.status == 'VERIFIED'" @click="purchase(row)"><span>$</span> Purchase</a>
                                            <a class="action action-green" v-else-if="user.id == row.customer_id" @click="verify(row)"><span>$</span> Verify</a>
                                        </template>
                                        <template v-else>
                                            <!-- <a class="action action-green" v-if="user.can_purchase != 3 && row.status == 'FINAL'" @click="verify(row)"><span>$</span> Verify</a>
                                            <a class="action action-green" v-else-if="user.can_purchase == 1 && row.status == 'VERIFIED'" @click="purchase(row)"><span>$</span> Purchase</a> -->
                                            <a class="action action-green" v-if="user.can_purchase != 3 && user.role !== 'project-manager' && row.status == 'FINAL'" @click="verify(row)"><span>$</span> Verify</a>
                                            <a class="action action-green" v-else-if="user.can_purchase == 1 && user.role !== 'project-manager' && row.status == 'VERIFIED'" @click="purchase(row)"><span>$</span> Purchase</a>
                                            <a class="action action-green" v-else-if="user.can_purchase == 2 && row.status == 'VERIFIED' && user.id == row.customer_id" @click="purchase(row)"><span>$</span> Purchase</a>
                                            <a class="action action-green" v-else-if="user.can_purchase == 3 && row.status != 'REQUESTED'" @click="verify(row)"><span>$</span> Request Purchase</a>
                                            <a class="action action-green" v-else-if="user.can_purchase == 4 && row.status == 'REQUESTED'" @click="purchase(row)"><span>$</span> Purchase</a>
                                        </template>
                                    </template>
                                    <a
                                        class="action action-blue"
                                        v-if="row.status.toUpperCase() == 'CUSTOM' && canUse('action_promote') && row.promoted != 'Yes' && getPM(row.customer_id) == user.username"
                                        @click="goPromote(row.id)"
                                    ><span>+</span>
                                        <template v-if="promoting == row.id"> Loading...</template>
                                        <template v-else> Promote</template>
                                    </a>
                                    <a href="javascript:void(0);"
                                        v-if="row.reject_comments && row.status.toUpperCase() == 'CUSTOM' && canUse('action_promote') && row.promoted != 'Yes' && getPM(row.customer_id) == user.username"
                                        @click="show_comments(row.reject_comments)"
                                        style="font-size: 16px;"
                                        title="Comments"
                                    >
                                        <span class="fa fa-comments"></span>
                                    </a>
                                    <template v-if="approving == row.id+'approve'">
                                        <a>Approving...</a>
                                    </template>
                                    <template v-else-if="approving == row.id+'reject'">
                                        <a>Rejecting</a>
                                    </template>
                                    <template v-else>
                                        <a class="action"
                                            v-if="row.status.toUpperCase() == 'CUSTOM' && row.promoted == 'Yes' && canUse('action_approve') && getPM(row.customer_id) != user.username"
                                            @click="actPromotion(row.id,'approve')"
                                        >
                                            <span>+</span>
                                            Approve
                                        </a>
                                        <a class="action action-red"
                                            v-if="row.status.toUpperCase() == 'CUSTOM' && row.promoted == 'Yes' && ((canUse('action_approve') && getPM(row.customer_id) != user.username) || getPM(row.customer_id) == user.username)"
                                            @click="actPromotion(row.id,'reject')"
                                        >
                                            <span>-</span>
                                            Reject
                                        </a>
                                    </template>
                                    <a class="action action-text" v-if="row.status.toUpperCase() == 'CUSTOM' && row.promoted == 'Yes' && getPM(row.customer_id) == user.username">For Approval</a>
                                </template>
                            </div>
                            <div class="action-links" v-if="(user.type=='administrative' || user.type=='managerial' || user.role=='Field') && user.id != row.customer_id && !canUse('subproject_edit')">
                                <template v-if="row.drawing_status != 'generating' && row.drawing_status != 'waiting' && row.drawing_status != 'processing'">
                                    <span v-if="(requesting3D.includes(row.id) || row.requested_3d == 'Yes') && !row.file_3d && row.status != 'CLOSED'">Requesting 3D...</span>
                                    <a @click="request3D(row.id,ri)" v-else-if="canUse('download_3d') && row.file_cad && !row.file_3d && (row.status=='FINAL' || row.status=='PROCESSED') && row.promoted != 'Yes' && canRequest3D(row.updated_at)">Request 3D</a>
                                    <a target="_blank" :href="fileUrl + row.file_3d" v-if="canUse('download_3d') && row.file_3d">3D{{ (row.revision === 'A' || row.revision === '') ? '' : `-${row.revision}` }}</a>
                                    <a target="_blank" :href="fileUrl + row.file_cad" v-if="canUse('download_cad') && row.file_cad">CAD{{ (row.revision === 'A' || row.revision === '') ? '' : `-${row.revision}` }}</a>
                                    <a target="_blank" :href="fileUrl + row.pdf_manu" v-if="row.pdf_manu">Manufacturing{{ (row.revision === 'A' || row.revision === '') ? '' : `-${row.revision}` }}</a>
                                </template>
                                <template v-if="user.role == 'project-manager' && row.status == 'CUSTOM'">
                                    <template v-if="row.phase != 'construction'">
                                        <router-link :to="'/initial/'+row.id" v-if="row.revision !== 'Z' && row.is_final != 'yes'">
                                            <span>Edit Initial</span>
                                        </router-link>
                                        <router-link :to="'/final/'+row.id" v-if="row.revision !== 'Z' && row.is_final == 'yes'">
                                            <span v-if="row.is_final == 'yes' && row.drawing_status != 'generating' && row.drawing_status != 'waiting' && row.drawing_status != 'processing'  && row.revision !== 'Z'">Edit Final</span>
                                        </router-link>
                                    </template>
                                    <template v-else>
                                        <router-link :to="'/construction/initial/'+row.id" v-if="row.revision !== 'Z' && row.is_final != 'yes'">
                                            <span>Edit Initial</span>
                                        </router-link>
                                        <router-link :to="'/construction/final/'+row.id" v-if="row.revision !== 'Z' && row.is_final == 'yes'">
                                            <span v-if="row.is_final == 'yes' && row.drawing_status != 'generating' && row.drawing_status != 'waiting' && row.drawing_status != 'processing' && row.revision !== 'Z'">Edit Final</span>
                                        </router-link>
                                    </template>
                                </template>
                                <template v-if="canUse('engineering_reports') && row.has_reports">
                                    <router-link
                                        :to="{
                                            name: 'Engineering Reports',
                                            params: {
                                                quoteNumber: row.quote_number
                                            }
                                        }"
                                    >Reports</router-link>
                                </template>
                                <a v-if="user.role == 'project-manager'" @click="addPlan(row)">Plan</a>
                                <a v-if="canUse('project_close') && row.phase != 'spareparts' && row.status != 'CLOSED'" @click="closeProject(row)">CLOSE</a>
                                <a v-else-if="canUse('project_close') && row.phase == 'spareparts' && row.status != 'CLOSED'" @click="closeSpareParts(row)">CLOSE</a>
                                <a v-if="canUse('project_delete') && row.phase != 'spareparts' && row.status == 'CLOSED'" @click="deleteProject(row)">DELETE</a>
                                <template v-if="canUse('sap_info')">
                                    <router-link 
                                        :to="{ 
                                            name: 'SAP Survey Info',
                                            params: {
                                                survey: row.id
                                            }
                                        }"
                                    >SAP</router-link>
                                </template>
                                <template v-if="row.phase != 'spareparts'">
                                    <span v-if="user.role=='project-manager'">
                                        <router-link :to="{ path: `/drawings/duplicate/${row.id}` }" >Copy Drawing</router-link>
                                        <a :href="'/api/download/input/'+row.id" target="_blank">Download Input</a>
                                        <a v-if="row.close_reason && row.status == 'CLOSED'" @click="goAlert(row.close_reason)">Reason</a>
                                        <a v-if="row.custom_message && row.status == 'CUSTOM'" @click="goAlert(row.custom_message)">Reason</a>
                                    </span>
                                    <span v-else-if="row.status == 'CUSTOM' && user.role!='Field'">
                                        <a :href="'/api/download/input/'+row.id" target="_blank">Download Input</a>
                                        <a v-if="row.custom_message" @click="goAlert(row.custom_message)">Reason</a>
                                    </span>
                                    <span v-if="user.type=='administrative'">
                                        <a v-if="row.close_reason && row.status == 'CLOSED'" @click="goAlert(row.close_reason)">Reason</a>
                                    </span>
                                    <template v-if="row.status == 'VERIFIED' || row.status == 'PURCHASED' || row.status == 'PROCESSED' || row.status == 'SHIPPED'">
                                        <template v-if="row.pdf_purchase_detail">
                                            <span class="pdf-list">
                                                <span style="cursor: default"><u>Purchase Details</u></span>
                                                <span class="pdf-list-options">
                                                    <a target="_blank" v-for="(path, pdkey) in row.pdf_purchase_detail.split(',')" :href="fileUrl + path + '&v=' + gt()" :key="pdkey">PD File {{ pdkey+1 }}</a>
                                                </span>
                                            </span>
                                        </template>
                                        <a target="_blank" :href="fileUrl + row.pdf_ds_documents" v-if="row.pdf_ds_documents">Docusign</a>
                                    </template>
                                    <span class="pdf-list" v-if="user.type=='administrative' || user.role=='project-manager' || row.status.toUpperCase() !== 'CUSTOM'">
                                        <template v-if="row.drawing_status == 'generating' || row.drawing_status == 'waiting' || row.drawing_status == 'processing'">
                                            <span v-if="row.status != 'CLOSED'">Generating...</span>
                                        </template>
                                        <template v-else>
                                            <span>PDF List</span>
                                            <span class="pdf-list-options">
                                                {{ row.is_final == 'yes' ? 'Final' : 'Initial'}} :
                                                <a target="_blank" :href="fileUrl + row.pdf_proposal + '&v=' + gt()" v-if="row.pdf_proposal">Proposal</a>
                                                <a target="_blank" :href="fileUrl + row.pdf_datasheet + '&v=' + gt()" v-if="row.pdf_datasheet">Datasheet</a>
                                                <a target="_blank" :href="fileUrl + row.pdf_controller + '&v=' + gt()" v-if="row.pdf_controller">Controller</a>
                                                <a target="_blank" :href="fileUrl + row.pdf_hpu + '&v=' + gt()" v-if="row.pdf_hpu">HPU</a>
                                                <!-- <a target="_blank" :href="apiUrl + row.pdf_drawing + '&v=' + gt()" v-if="row.pdf_drawing">Drawing(s)</a> -->
                                                <a v-if="row.pdf_drawing || row.pdf_cssv" :href="'/api/download/drawings-cssv/'+row.id" target="_blank">Drawing(s)</a>
                                                <a target="_blank" :href="fileUrl + row.pdf_machines + '&v=' + gt()" v-if="!row.pdf_drawing && row.pdf_machines">Drawing(s)</a>
                                                <a target="_blank" :href="fileUrl + row.pdf_traction + '&v=' + gt()" v-if="row.pdf_traction">Traction</a>
                                                <a target="_blank" :href="fileUrl + row.pdf_reaction + '&v=' + gt()" v-if="row.pdf_reaction">Reaction</a>
                                                <a target="_blank" :href="fileUrl + row.pdf_ropelife + '&v=' + gt()" v-if="row.pdf_ropelife">Rope Life</a>
                                                <a target="_blank" :href="fileUrl + row.pdf_drill + '&v=' + gt()" v-if="row.pdf_drill">Drill</a>
                                                <a target="_blank" :href="fileUrl + row.zip_datatag + '&v=' + gt()" v-if="row.zip_datatag">Datatag</a>
                                                <template v-if="row.pdf_po && (row.status == 'PURCHASED' || row.status == 'PROCESSED' || row.status == 'SHIPPED')">
                                                    <a target="_blank" v-for="(path, key) in row.pdf_po.split(',')" :href="fileUrl + path + '&v=' + gt()" :key="key">PO File {{ key+1 }}</a>
                                                </template>
                                                <a target="_blank" :href="fileUrl + row.pdf_reject + '?v=' + gt()" v-if="row.pdf_reject && row.status == 'CUSTOM'">Reject File</a>
                                                <a v-if="user.role=='project-manager'" target="_blank" :href="'/api/download/project-all/'+row.id">Download All</a>
                                            </span>
                                        </template>
                                    </span>
                                </template>
                                <template v-else-if="row.phase == 'spareparts'">
                                    <a target="_blank" :href="fileUrl + row.pdf_order" v-if="row.pdf_order">Order Details</a>
                                    <a v-if="row.po_file && row.po_file !== ''" :href="fileUrl + row.po_file" target="_blank" >PO File</a>
                                    <template v-if="user.role=='project-manager'">
                                        <a :href="'/api/download/spare-all/'+row.id" target="_blank">Download All</a>
                                    </template>
                                </template>
                            </div>
                            <div class="action-links" v-else>
                                <a href="/quote/" target="_blank" v-if="row.machine_location == 'BASEMENT' && row.status ==  'INITIAL'">Survey</a>
                                <template v-if="row.drawing_status != 'generating' && row.drawing_status != 'waiting' && row.drawing_status != 'processing'">
                                    <span v-if="(requesting3D[row.id] || row.requested_3d == 'Yes') && !row.file_3d">Requesting 3D...</span>
                                    <a @click="request3D(row.id,ri)" v-else-if="canUse('download_3d') && row.file_cad && !row.file_3d && (row.status=='FINAL' || (row.status=='PROCESSED' && user.role == 'super-user')) && row.promoted != 'Yes' && canRequest3D(row.updated_at)">Request 3D</a>
                                    <a target="_blank" :href="fileUrl + row.file_3d" v-if="canUse('download_3d') && row.file_3d && row.status != 'CUSTOM'">3D{{ (row.revision === 'A' || row.revision === '') ? '' : `-${row.revision}` }}</a>
                                    <a target="_blank" :href="fileUrl + row.file_cad" v-if="canUse('download_cad') && row.file_cad && row.status != 'CUSTOM'">CAD{{ (row.revision === 'A' || row.revision === '') ? '' : `-${row.revision}` }}</a>
                                </template>
                                <template v-if="row.phase != 'construction'">
                                    <router-link :to="'/initial/'+row.id" v-if="row.revision !== 'Z' && row.status == 'INITIAL'">
                                        <span>Edit Initial</span>
                                    </router-link>
                                    <router-link :to="'/final/'+row.id">
                                        <span v-if="row.status == 'INITIAL'">Request Final</span>
                                        <span v-if="row.status == 'FINAL' && row.drawing_status != 'generating' && row.drawing_status != 'waiting' && row.drawing_status != 'processing'  && row.revision !== 'Z'">Edit Final</span>
                                    </router-link>
                                    <router-link :to="'/duplicate/'+row.id" v-if="row.phase != 'spareparts'">DUPLICATE</router-link>
                                </template>
                                <template v-else>
                                    <router-link :to="'/construction/initial/'+row.id" v-if="row.revision !== 'Z' && row.status == 'INITIAL'">
                                      <span>Edit Initial</span>
                                    </router-link>
                                    <router-link :to="'/construction/final/'+row.id">
                                        <span v-if="row.status == 'INITIAL'">Request Final</span>
                                        <span v-if="row.status == 'FINAL' && row.drawing_status != 'generating' && row.drawing_status != 'waiting' && row.drawing_status != 'processing' && row.revision !== 'Z'">Edit Final</span>
                                    </router-link>
                                    <router-link :to="'/construction/duplicate/'+row.id" v-if="row.phase != 'spareparts'">DUPLICATE</router-link>
                                </template>
                                <a v-if="canUse('project_delete') && row.phase != 'spareparts' && row.status == 'CLOSED'" @click="deleteProject(row)">DELETE</a>
                                <a v-if="row.phase != 'spareparts' && row.status !== 'CLOSED'" @click="closeProject(row)">CLOSE</a>
                                <a v-else-if="row.phase === 'spareparts' && row.status !== 'CLOSED'" @click="closeSpareParts(row)">CLOSE</a>
                                <span v-if="row.status == 'CUSTOM'">
                                    <a :href="'/api/download/input/'+row.id" target="_blank">Download Input</a>
                                </span>
                                <span v-else-if="row.drawing_status == 'generating'">
                                    <span class="ml-2" v-if="row.status != 'CLOSED'">GENERATING...</span>
                                </span>
                                <span v-else-if="row.drawing_status == 'waiting' || row.drawing_status == 'processing' ">
                                    <span class="ml-2" v-if="row.status != 'CLOSED'">GENERATING....</span>
                                </span>
                                <span v-else-if="row.drawing_status == 'failed'">
                                    <span class="ml-2">DRAWING FAILED</span>
                                </span>
                                <span v-else>
                                    <template v-if="row.status != 'CUSTOM'">
                                        <template v-if="row.pdf_proposal && !row.pdf_proposal.includes('-CUSTOM-')">
                                            <a target="_blank" :href="fileUrl + row.pdf_proposal" v-if="row.pdf_proposal">{{ row.is_final != 'yes' || row.status === 'INITIAL' ? 'Initial' : 'Final' }} Proposal</a>
                                            <a target="_blank" :href="fileUrl + row.pdf_datasheet" v-if="row.pdf_datasheet && row.phase != 'construction'">{{ row.is_final != 'yes' || row.status === 'INITIAL' ? 'Initial' : 'Final' }} Datasheet</a>
                                        </template>
                                        <template v-if="row.project_name == 'Spare Parts'">
                                            <a target="_blank" :href="fileUrl + row.pdf_order" v-if="row.pdf_order">Order Details</a>
                                        </template>
                                    </template>
                                    <template v-if="row.status == 'VERIFIED' || row.status == 'PURCHASED' || row.status == 'PROCESSED' || row.status == 'SHIPPED'">
                                        <template v-if="row.pdf_purchase_detail">
                                            <span class="pdf-list">
                                                <span style="cursor: default"><u>Purchase Details</u></span>
                                                <span class="pdf-list-options">
                                                    <a target="_blank" v-for="(path, pddkey) in row.pdf_purchase_detail.split(',')" :href="fileUrl + path + '&v=' + gt()" :key="pddkey">PD File {{ pddkey+1 }}</a>
                                                </span>
                                            </span>
                                        </template>
                                        <a target="_blank" :href="fileUrl + row.pdf_ds_documents" v-if="row.pdf_ds_documents">Docusign</a>
                                    </template>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="projects.length == 0 && !isLoading">
                <p class="no-results-msg">No results found</p>
            </template>
            <template v-if="isLoading">
                <div class="progress">
                    <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
                </div>
            </template>
        </div>
        <br>
        <div class="button-group">
            <template v-if="(user.role == 'super_admin' || user.role == 'administrator') && ['YES','NO'].includes(filters.pending_close)">
                <div class="btn-bulk-close position-relative">
                    <button class="btn" @click="bulk_close_project">Bulk Close ({{ selected_projects.length }})</button>
                    <button class="btn btnDeselectAllProjects" title="Deselect All Project" @click="deselect_all_projects">&times;</button>
                </div>
            </template>
            <template v-if="user.role == 'customer'">
                <router-link :to="'/form/initial'" class="btn btn-black">New Quote</router-link>
                <router-link :to="'/form/final'" class="btn btn-black">New Final Quote</router-link>
            </template>
            <a class="btn btn-black" :href="`/api/projects/export?filters=${JSON.stringify(filters)}&order_by=${order_by}&order=${order}&subproject=${subproject}`" data-export>Export Quotes to CSV</a>
            <a class="btn btn-black" :href="`/api/projects/export_machine_type?filters=${JSON.stringify(filters)}&order_by=${order_by}&order=${order}&subproject=${subproject}`" data-export>Export By Machine Type</a>
            <template v-if="user.role == 'project-manager'">
                <a class="btn btn-black" @click="goPromote('new')">
                    <template v-if="promoting == 'new'"> Loading...</template>
                    <template v-else>Promote From Scratch</template>
                </a>
                <a class="btn btn-black" :href="`/api/projects/export_history?filters=${JSON.stringify(filters)}&order_by=${order_by}&order=${order}&subproject=${subproject}`" data-export>Export History</a>
            </template>
            <template v-if="user.role == 'super_admin' || user.role == 'administrator'">
                <a class="btn btn-black" :href="`/api/projects/export_west_coast?filters=${JSON.stringify(filters)}&order_by=${order_by}&order=${order}&subproject=${subproject}`" data-export>West Coast Quotes</a>
                <a class="btn btn-black" :href="`/api/projects/export_survey_answers?filters=${JSON.stringify(filters)}&order_by=${order_by}&order=${order}&subproject=${subproject}`" data-export>Export Survey Answers</a>
                <a class="btn btn-black" :href="`/api/projects/export_history?filters=${JSON.stringify(filters)}&order_by=${order_by}&order=${order}&subproject=${subproject}`" data-export>Export History</a>
            </template>
        </div>

        <div class="side-modal-wrap" v-if="detail">
            <div class="side-modal-bd" @click="closeDetail"></div>

            <div class="side-modal">
                <div class="sider-header">
                    {{ detail.quote_number }}
                    <a class="close-detail" @click="closeDetail">&times;</a>
                </div>
                <div class="sider-body container">
                    <h3>Details</h3>
                    <div class="row">
                        <div class="col-lg-4 info-col">Project Name:</div>
                        <div class="col"><label>{{ detail.project_name }}</label></div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4 info-col">Date Submitted:</div>
                        <div class="col"><label>{{ detail.updated_at }}</label></div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4 info-col">Total:</div>
                        <div class="col"><label>{{ detail.total_price }}</label></div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4 info-col">Status:</div>
                        <div class="col">
                            <label>
                                <badge class="badge-dot mr-4" :type="detail.status.toLowerCase()">
                                  <span class="status">{{detail.status}}</span>
                                </badge>
                            </label>
                        </div>
                    </div>
                    <div class="row" v-if="detail.status == 'CUSTOM'">
                        <div class="col-lg-4 info-col">Reason:</div>
                        <div class="col">
                            <label>
                                {{ detail.custom_message }}
                            </label>
                        </div>
                    </div>
                    <br>
                    <div>
                        <h3>Actions</h3>
                        <base-button type="primary" size="sm" v-if="detail.status == 'INITIAL'">Request Final</base-button>
                        <base-button type="primary" size="sm" v-if="detail.status == 'FINAL'">Edit Final</base-button>
                        <base-button type="primary" size="sm">Duplicate</base-button>
                        <base-button type="success" size="sm" v-if="detail.status == 'FINAL'">Purchase</base-button>
                        <base-button type="warning" size="sm" v-if="detail.status == 'CUSTOM'">Download Inputs</base-button>
                        <base-button type="danger" size="sm" v-if="detail.status != 'CLOSED'">Close</base-button>
                    </div>
                    <br>
                    <br>
                    <div>
                        <h3>Files</h3>
                        <ul>
                            <li v-if="detail.pdf_proposal">
                                Proposal
                                <a :href="apiUrl + detail.pdf_proposal" target="_blank">View</a>
                            </li>
                            <li v-if="detail.pdf_datasheet">
                                Datasheet
                                <a :href="apiUrl + detail.pdf_datasheet" target="_blank">View</a>
                            </li>
                            <li v-if="detail.pdf_drawing">
                                Drawing
                                <a :href="apiUrl + detail.pdf_drawing" target="_blank">View</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <promotion v-if="promotionModalKey > 0 || promotionModalKey == 'new'" :key="promotionModalKey" :pdata="toPromote" @reload="loadProjects(1)" @close="toPromote = false"></promotion>
        <verify-modal v-if="verifyModalKey > 0" :key="verifyModalKey" :show="showVerifyModal" :survey="survey" @close="showVerifyModal = false" @reload="loadProjects(1)"></verify-modal>
        <purchase-modal v-if="purchaseModalKey > 0" :key="purchaseModalKey" :show="showPurchaseModal" :survey="survey" @close="showPurchaseModal = false" @reload="loadProjects(1)"></purchase-modal>
        <response-code-modal v-if="showToResponse" :key="responseModalKey" :proposal="toResponse" @close="handleCloseResponseModal" @updated="handleUpdatedResponseModal"></response-code-modal>
        <close-reason-modal v-if="showToCloseReason" :key="closeReasonModalKey" :project="toCloseReason" @close="handleCloseReason" @updated="handleUpdatedCloseReason"></close-reason-modal>
        <planning-modal v-if="showPlanningModal" :ids="planning_ids" :qns="planning_qns" :rsurvey="rsurvey" @close="handleClosePlanning"></planning-modal>
    </div>
</template>
<script>
import ProjectsFilter from '../components/ProjectsFilter';
import VerifyModal from '../components/Modals/VerifyModal';
import PurchaseModal from '../components/Modals/PurchaseModal';
import Promotion from '../components/Modals/Promotion';
import ResponseCodeModal from '../components/Modals/ResponseCodeModal';
import CloseReasonModal from '../components/Modals/CloseReasonModal';
import PlanningModal from '../components/Modals/PlanningModal';

  export default {
    name: 'tables',
    components: {
        ProjectsFilter,
        Promotion,
        VerifyModal,
        PurchaseModal,
        ResponseCodeModal,
        CloseReasonModal,
        PlanningModal
    },
    props: {
      type: {
        type: String
      },
      title: String
    },
    data() {
      return {
        lid: 17895,
        gen3dstart: 0,
        apiUrl: '/api/',
        fileUrl: '/file?f=',
        reseter: { counter : 1 },
        liveUrl: 'https://torindrivena.com/project/',
        requesting3D: [],
        checking: false,
        detail: false,
        search: '',
        page: 1,
        toPromote: false,
        isLoading: false,
        isDLoading: false,
        drawCheck: false,
        generating: false,
        waiting: false,
        user: [],
        users: [],
        projects: [],
        subproject: false,
        rsurvey: false,
        purchaseModalKey: 0,
        showPurchaseModal: false,
        verifyModalKey: 0,
        showVerifyModal: false,
        survey: false,
        promoting: false,
        approving: false,
        denying: false,
        is3DRequest: false,
        filters: {},
        order_by: 'updated_at',
        order: 'desc',
        promotionModalKey: 0,
        default_select_all_project: false,
        selected_projects: [],
        select_all_project_filters: [],
        loadedFilters: false,
        showToResponse: false,
        toResponse: {},
        responseModalKey: 0,
        closeReasonModalKey: 0,
        showToCloseReason: false,
        planning_ids: 0,
        planning_qns: 0,
        showPlanningModal: false,
        toCloseReason: {},
        isPriceUpdating: false,
        toPriceUpdateID: 0
      }
    },
    watch: {
        '$route': function() {
            this.subproject = this.$attrs.subproject;
            this.loadProjects(1);
            this.me();
        }
    },
    mounted() {
        let def_order = document.querySelector('#list-proj .list-head .col[data-key='+this.order_by+']')
        def_order.classList.add(this.order)
        def_order.dataset.order = (this.order == 'asc' ? 'desc' : 'asc')

        document.getElementById("list-proj").addEventListener('scroll', this.scrollProj);
        this.subproject = this.$attrs.subproject;

        // this.loadProjects(1);
        this.isLoading = true
    },
    methods: {
        gLid(id) {
            return ( id <= this.lid ) ? this.liveUrl : this.apiUrl;
        },
        me() {
            this.$http.get('/api/me').then((r) => {
                localStorage.setItem('user', JSON.stringify(r.data));
                this.user = r.data;
            });
        },
        gt(){
            var d = new Date();
            return d.getTime();
        },
        scrollProj({ target: { scrollTop, clientHeight, scrollHeight }}) {
            this.toPromote = false;
            if (scrollTop + clientHeight >= (scrollHeight - 100) && !this.stopLoads && !this.isLoading) {
                if(this.filters.pending_close != 'YES') {
                    this.page += 1;
                    this.loadProjects(this.page);
                }
            }
        },
        reset(){
            var ctr = this.reseter.counter;
            this.$set(this.reseter,'counter',ctr+2);
            this.$set(this.reseter,'counter',ctr+1);
        },
        canUse(f) {
            if ( !this.user.functions ) return false;
            return this.user.functions.includes(f);
        },
        goAlert(message) {
            alert(message);
            return false;
        },
        isRequesting3D(project_id) {
            if ( !this.user.requesting3D ) return false;
            return this.user.requesting3D.includes(project_id);
        },
        actPromotion(project_id,action) {
            if ( this.approving ) return false;
            if ( !confirm('Are you sure want to '+action+' this promotion?') ) return false;
            this.approving = project_id+action;
            let api = '/api/promote/'+action+'/'+project_id;

            if(action == 'reject') {
                let comment = this.reject_comment();
                if(comment) {
                    api = api.concat(`?comment=${comment}`);
                } else {
                    this.approving = false;
                    return false;
                }
            }

            this.$http.get(api).then(() => {
                this.approving = false;
                let msg = action == 'approve' ? 'Approved' : 'Rejected';
                alert('Project has been '+msg+' successfully!');
                this.loadProjects(1);
            })
            .catch((error) => {
                console.log(error);
                alert('Error occured.');
                this.approving = false;
            });
        },
        reject_comment() {
            let comment = prompt('Please enter your comments.')
            if(comment == '') {
                return this.reject_comment()
            }
            return comment
        },
        show_comments(comments) {
            alert(comments)
        },
        goPromote(project_id) {
            if ( this.promoting ) return false;
            this.promoting = project_id;
            const api = '/api/promote/get/'+project_id;
            this.promotionModalKey = 0;
            this.$http.get(api).then((response) => {
                this.promoting = false;
                this.toPromote = response.data;
                this.promotionModalKey = project_id;
            })
            .catch((error) => {
                console.log(error)
                this.promoting = false;
            });
        },
        handleLoadedFilters(filters) {
          this.loadedFilters = true;
          this.filters = filters;
          this.loadProjects(1);
        },
        loadProjects(page) {
            // console.log('loadProjects');

            var user = localStorage.getItem('user'),
                link = this.subproject ? 'subprojects' : 'projects';
            if ( !user ) this.$router.push('login');
            this.user = JSON.parse(user);

            if ( page == 1 ) {
                this.projects = [];
                this.page = 1;
                this.stopLoads = false;
            }

            // console.log(location.hash, this.filters);
            if ( location.hash && Object.keys(this.filters).length === 0 ) {
                this.filters = {status:location.hash.replace('#','')};
                history.replaceState("", document.title, window.location.pathname + window.location.search);
            }

            const dfilters = {...{}, ...{for:'get'}, ...this.filters};
            dfilters.search = dfilters.search.replace('#',':hash:');
            const pdata = {};
            pdata.filters = dfilters;
            pdata.order_by = this.order_by;
            pdata.order = this.order;

            const api = this.apiUrl+link+'/'+ page;
            this.isLoading = true;
            this.$http.post(api,pdata).then((response) => {
                if ( response.data.users.length ) this.users = response.data.users;

                if ( response.data.gen3dstart ) this.gen3dstart = response.data.gen3dstart;

                if ( page == 1 ) this.projects = response.data.projects;
                else this.projects = this.projects.concat(response.data.projects);

                if ( !response.data.projects.length ) this.stopLoads = true;

                this.generating = this.projects.filter(p => p.drawing_status == "generating");
                if ( this.generating ) this.checkDrawings();

                var r3ds = this.projects.filter(p => p.requested_3d == "Yes" && !p.file_3d);
                if ( r3ds.length > 0 ) this.check3Ds();

                this.waiting = this.projects.filter(p => p.drawing_status == "waiting");
                if ( this.waiting ) this.checkWaiting();

                this.survey = [];
                this.isLoading = false;
            });
        },
        formatPrice(value) {
            let val = (value/1).toFixed(2);
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        getCompany(customer_id) {
            for ( var u in this.users ) {
                if ( this.users[u].id == customer_id )
                    if( this.users[u].username && this.users[u].username != 'null' )
                        return this.users[u].company;
            }
            return '-';
        },
        getSubsidiary(customer_id) {
            for ( var u in this.users ) {
                if ( this.users[u].id == customer_id )
                    // if( this.users[u].username && this.users[u].username != 'null' )
                    //     return this.users[u].username;
                    if( this.users[u].username && this.users[u].username != 'null' )
                        return this.users[u].company;
            }
            return '-';
        },
        getRegion(customer_id) {
            for ( var u in this.users ) {
                if ( this.users[u].id == customer_id )
                    if( this.users[u].managers && this.users[u].managers != 'null' )
                        return this.users[u].managers;
            }
            return '-';
        },
        getPM(customer_id) {
            for ( var u in this.users ) {
                if ( this.users[u].id == customer_id ) return this.users[u].pm;
            }
            return '-';
        },
        canRequest3D(pDate) {
            var myDate = pDate.split(' ')[0];
            myDate = myDate.split("-");
            var newDate = new Date( myDate[0], myDate[1] - 1, myDate[2]);
            var timestamp = Math.floor(newDate.getTime() / 1000);
            console.log(timestamp+' > ', this.gen3dstart);
            return timestamp > this.gen3dstart;
        },
        checkWaiting() {
            const api = this.apiUrl+'check/waiting';
            var waiting = [];
            this.projects.map(function(o,i){
                if ( o.drawing_status == "waiting" ) waiting.push({ key : i, id : o.id });
            });
            this.$http.get(api).then((response) => {
                for(var w in waiting) this.projects[waiting[w].key].drawing_status = 'generating';
                if ( response.data.length ) this.checkDrawings();
                // console.log(response);
            });
        },
        check3Ds() {
            // console.log('check3Ds');
            if ( this.is3DRequest ) return false;

            const api = this.apiUrl+'check/generated3D';
            var dataParams = { ids : [] };
            this.projects.map(function(o){
                if ( o.requested_3d == "Yes" && !o.file_3d ) dataParams.ids.push(o.id);
            });
            this.is3DRequest = true;
            if ( dataParams.ids === [] ) return false;

            this.$http.get(api,{ params: dataParams })
                .then((response) => {
                    this.is3DRequest = false;
                    const genProjects = response.data;
                    if ( genProjects.length > 0 ) {
                        for(var x in genProjects ) {
                            this.projects.map(function(o,i){
                                if ( o.id == genProjects[x].id && genProjects[x].file_3d ) {
                                    alert(genProjects[x].quote_number+' 3D has been generated.');
                                    o.file_3d = genProjects[x].file_3d;
                                    this.$set(this.projects[i],'file_3d',genProjects[x].file_3d);
                                    this.$set(this.projects[i],'requested_3d','');

                                    for ( var r3 in this.requesting3D ) {
                                        if ( this.requesting3D[r3] == o.id ) delete this.requesting3D[r3];
                                    }
                                }
                            });
                            this.reset();
                        }
                    } else if ( this.$route.path === '/projects' ) {
                        setTimeout(this.check3Ds,5000);
                    }
                })
                .catch((error) => {
                    console.log(error)
                    this.is3DRequest = false;
                });
        },
        checkDrawings() {
            // console.log('checkDrawings');
            if ( this.checking ) return false;

            var generating = [];
            this.projects.map(function(o,i){
                if ( o.drawing_status == "generating" && o.status == "FINAL" ) generating.push({ key : i, id : o.id });
                // else break;
            });
            this.generating = generating;
            if ( !generating.length ) return false;

            const api = this.apiUrl+'check/generated';
            var dataParams = { ids : [] };
            for ( var i in this.generating ) dataParams.ids.push(this.generating[i].id);
            this.checking = true;
            this.$http.get(api,{ params: dataParams })
                .then((response) => {
                    this.checking = false;
                    const genProjects = response.data;
                    if ( genProjects.length > 0 ) {
                        for(var i in genProjects ) {
                            var proj = this.generating.filter(p => p.id == genProjects[i].id);
                            if ( proj.length > 0 ) {
                                this.$set(this.projects,proj[0].key,genProjects[i]);
                                alert(genProjects[i].quote_number+' drawing has been generated.');
                            }
                        }
                    } else if ( this.$route.path === '/projects' ) {
                        setTimeout(this.checkDrawings,5000);
                    }
                })
                .catch((error) => {
                    console.log(error)
                    this.checking = false;
                });
        },
        closeDetail() {
            this.detail = false;
        },
        deleteProject(row) {
            if ( confirm('Are you sure you want to delete "'+row.quote_number+'"?') ) {
                const api = '/api/delete/'+row.id;
                this.$http.post(api).then(() => {
                    this.loadProjects(1);
                }).catch(error => {
                    console.log(error);
                    if ( error.response.data.message ) {
                        alert(error.response.data.message);
                    }
                })
            }
            return false;
        },
        closeProject(row) {
            this.toCloseReason = Object.assign({}, row)
            this.closeReasonModalKey = this.toCloseReason.id
            this.showToCloseReason = true
        },
        addPlan(row) {
            // const api = '/api/planning/add/'+row.id;
            // this.$http.post(api).then(() => {
            //     this.$router.push('/planning').catch(() => {});
            // }).catch(error => {
            //     console.log(error);
            //     if ( error.response.data.message ) {
            //         alert(error.response.data.message);
            //     }
            // })
            this.showPlanningModal = true;
            this.rsurvey = row;
            this.planning_ids = row.id;
            this.planning_qns = row.quote_number;
        },
        closeSpareParts(row) {
            this.toCloseReason = Object.assign({}, row)
            this.closeReasonModalKey = this.toCloseReason.id
            this.showToCloseReason = true
        },
        request3D(project_id,ri) {
            this.requesting3D.push(project_id);
            const api = this.apiUrl+'request3D/'+project_id;
            this.$http.get(api).then((response) => {
                var r = response.data;
                // console.log('respo request 3D', r);
                if ( r.status == 'success' ) this.$set(this.projects,ri,r.project);
                if ( r.status == 'waiting' ) {
                    alert('Waiting for 3D to be generated');
                    this.$set(this.projects[ri],'requested_3d','Yes');
                    this.check3Ds();
                }

                if ( r.status == 'failed' ) {
                    alert('Error: ' + r.message);
                } else {
                    for ( var r3 in this.requesting3D ) {
                        if ( this.requesting3D[r3] == project_id ) delete this.requesting3D[r3];
                    }
                }
            });
        },
        getDetail(project_id) {
            const api = this.apiUrl+'api/portal/myproject/'+project_id;
            this.isDLoading = project_id;
            this.$http.get(api).then((response) => {
                this.isDLoading = false;
                this.detail = response.data;
            });
        },
        verify(row) {
            this.showVerifyModal = true;
            this.verifyModalKey = row.id;
            this.survey = row;
        },
        purchase(row) {
            this.showPurchaseModal = true;
            this.purchaseModalKey = row.id;
            this.survey = row;
        },
        priceUpdate(projectID) {
            this.isPriceUpdating = true
            this.toPriceUpdateID = projectID
            this.$http.post(`/api/settings/reprice/${projectID}`).then(() => {
                this.isPriceUpdating = false
                this.toPriceUpdateID = 0
                this.loadProjects(1)
            }).catch(() => {
                this.isPriceUpdating = false
                this.toPriceUpdateID = 0
            })
        },
        filter_project(filters) {
            this.filters = filters;
            this.loadProjects(1);
        },
        sort_list(e) {
            if(!this.isListLoading) {
                Array.from(document.querySelectorAll('#list-proj .list-head .col')).forEach((el) => {
                    el.classList.remove('asc', 'desc')
                })
                let element = document.querySelector('#list-proj .list-head .col[data-key='+e.target.dataset.key+']')
                this.order_by = e.target.dataset.key
                this.order = element.dataset.order || 'asc'
                element.classList.add(this.order)
                element.dataset.order = (this.order == 'asc' ? 'desc' : 'asc')
                this.loadProjects(1)
            }
        },
        select_all_projects(e) {
            // save select all filter
            let filters = JSON.stringify(this.filters)
            if(e.target.checked) {
                if(this.select_all_project_filters.indexOf(filters) == -1) {
                    this.select_all_project_filters.push(filters)
                }
            } else {
                this.select_all_project_filters.splice(this.select_all_project_filters.indexOf(filters), 1)
            }
            // select all project
            let ids = this.projects
            for(let n in ids) {
                this.select_project(e, ids[n].id)
            }
        },
        select_project(e, id) {
            if(e.target.checked) {
                if(this.selected_projects.indexOf(id) == -1) {
                    this.selected_projects.push(id)
                }
            } else {
                this.selected_projects.splice(this.selected_projects.indexOf(id), 1)
            }
        },
        deselect_all_projects() {
            this.default_select_all_project = false
            this.selected_projects = []
            this.select_all_project_filters = []
        },
        bulk_close_project() {
            if(this.selected_projects.length > 0) {
                let conf = confirm('Are you sure you want to close these projects?')
                if(conf) {
                    this.$http.post('/api/projects/bulk-close', { ids: this.selected_projects })
                        .then(() => {
                            this.deselect_all_projects()
                            this.loadProjects(1)
                        })
                        .catch(error => {
                            if(error.response.data.message == 'validation_error') {
                                let errors = error.response.data.errors
                                if(Object.keys(errors).length == 1) {
                                    alert(errors[Object.keys(errors)[0]][0])
                                }
                            }
                        })
                }
            } else {
                alert('No project selected.')
            }
        },
        handleResponse(row) {
            this.toResponse = Object.assign({}, row)
            this.responseModalKey = this.toResponse.id
            this.showToResponse = true
        },
        handleCloseResponseModal() {
            this.toResponse = Object.assign({}, {})
            this.showToResponse = false
            this.responseModalKey = 0
        },
        handleUpdatedResponseModal() {
            this.toResponse = Object.assign({}, {})
            this.loadProjects(1)
            this.showToResponse = false
            this.responseModalKey = 0
        },
        handleCloseReason() {
            this.toCloseReason = Object.assign({}, {})
            this.showToCloseReason = false
            this.closeReasonModalKey = 0
        },
        handleClosePlanning() {
            this.rsurvey = false
            this.planning_ids = 0
            this.planning_qns = 0
            this.showPlanningModal = false
        },
        handleUpdatedCloseReason() {
            this.toCloseReason = Object.assign({}, {})
            alert('Project closed!');
            this.loadProjects(1)
            this.showToCloseReason = false
            this.closeReasonModalKey = 0
        }
    },
    beforeMount(){
      // this.loadProjects(1);
      // console.log('beforeMount');
      if (localStorage.getItem('user') && localStorage.getItem('need_reset') === '1') {
        this.$router.push('/reset').catch(() => {});
      }
    }
  };
</script>
<style lang="scss">
    .pdf-list { text-transform: uppercase; position: relative; padding: 3px; }
    .pdf-list a { display: inline-block; }
    .pdf-list > span { display: inline-block; padding: 3px; }
    .pdf-list > .pdf-list-options, .pdf-list > .pdf-list-options a { color: #000 !important; }
    .pdf-list .pdf-list-options { display: none; position: absolute; top: 100%; right: 0; background: #FFF; padding: 4px 6px; white-space: nowrap; }
    .pdf-list:hover .pdf-list-options { display: block; }
    .list-proj .pdf-list .pdf-list-options a { margin: 0; }
    .list-proj .row .badge-dot { margin: 0 0 0 6px !important; line-height: 16px; }
    .list-proj .row .action{ display: inline-block; padding: 7px; border: 0; letter-spacing: 0.3px; color: #fff; text-decoration: none; min-width: 86px; cursor: pointer; color: #fff; background-color: #5cb85c; margin-left: 6px; vertical-align: bottom; }
    .list-proj .row .action span { display: inline-block; background: #459e45; padding: 2px 7px; width: 29px; margin: -7px 2px -7px -8px; font-size: 17px; line-height: 26px; text-align: center; }
    .list-proj .row .action.action-blue{ background: #337ab7; }
    .list-proj .row .action.action-red{ background: #c90000; }
    .list-proj .row .action.action-text{ background: transparent; color: #000; cursor: text; }
    .list-proj .row .action.action-blue span { background: #055091; }
    .list-proj .row .action.action-red span { background: #8b0000; }
    .list-proj .row .action.action-center{ text-align: center; }
    .list-proj .row .ses-sonum { display: inline-block; max-height: 28px; overflow: hidden; vertical-align: middle; }
    .list-proj .row .ses-sonum:hover { overflow-y: scroll; }
    .list-proj .row.list-action .action-links a { margin-left: 4px; letter-spacing: -0.5px; }
    .modal-body { max-height : calc(100vh - 200px); overflow: auto; }
    .ses-phase { position: absolute; top: -6px; left: 21px; background: orange; padding: 1px 6px; display: inline-block; min-width: 84px; text-align: center; }
    .badge-response-code {
        background-color: transparent !important;
        color: #000 !important;
        font-size: 10px !important;
    }
    .badge-pending-close {
        background-color: transparent !important;
        color: #c90000 !important;
        font-size: 10px !important;
    }
    .badge-delivered {
        background-color: #ff8800 !important;
        color: #ffffff !important;
    }
    .badge-delivered-arrived-cfs-on-rail {
        background-color: #00ff99 !important;
        color: #ffffff !important;
    }
    .badge-delivered-arrived-cfs-on-rail {
        background-color: #00ff99 !important;
        color: #ffffff !important;
    }
    .badge-delivered-arrived-des-port {
        background-color: #449944 !important;
        color: #ffffff !important;
    }
    .badge-delivered-booked {
        background-color: #3377bb !important;
        color: #ffffff !important;
    }
    .badge-delivered-closed {
        background-color: #ee0000 !important;
        color: #ffffff !important;
    }
    .badge-delivered-waiting-for-rail {
        background-color: #ff7700 !important;
        color: #000000 !important;
    }
    .badge-delivered-water {
        background-color: #1100ff !important;
        color: #ffffff !important;
    }
    .progress {
        border-radius: 0;
    }
    .no-results-msg {
        text-align: center;
        padding: 0.5em;
        font-size: 11px !important;
    }
    #list-proj {
        min-width: 700px;
        padding-right: 12px;
        .list-head .col {
            display: flex;
            justify-content: center;
            align-items: center;
            background-image: url('/api/public/img/bg.png');
            background-position: center right;
            background-repeat: no-repeat;
            cursor: pointer;
            white-space: normal;
            &.asc {
                background-image: url('/api/public/img/trans-asc.png');
            }
            &.desc {
                background-image: url('/api/public/img/trans-desc.png');
            }
            &.sort-false {
                background-image: none;
                cursor: default;
            }
        }
        .list-row:last-child {
            padding-bottom: 1.5em;
        }
        .price-info {
            color: black;
            text-transform: uppercase;
            text-align: center;
            display: inline-block;
            width: 100%;
            cursor: help;
        }
        .price-update {
            text-align: center;
            display: inline-block;
            width: 100%;
        }
        .price-btn {
            line-height: 16px;
            text-decoration: none;
        }
    }
    @media (max-width: 768px) {
        #list-proj {
            min-width: 1200px;
        }
    }
    .col-check-th,
    .col-check-td {
        flex-grow: 0;
    }
    .col-check-th {
        padding-left: 32px;
    }
    .col-check-td {
        padding-left: 25px;
    }
    .btnDeselectAllProjects {
        background-color: #c90000;
        color: #fff;
        font-size: 11px;
        border-radius: 50%;
        height: 24px;
        width: 24px !important;
        padding: 0;
        position: absolute;
        z-index: 10;
        right: -14px;
        top: -9px;
        &:hover {
            color: #000;
        }
    }
    .button-group {
        .btn-bulk-close {
            width: 100%;
            margin-right: 0;
            .btn {
                width: 100%;
            }
        }
    }
    @media (min-width: 568px) {
        .button-group {
            .btn-bulk-close {
                width: 48%;
                margin-right: 8px;
            }
        }
    }
    @media (min-width: 992px) {
        .button-group {
            .btn-bulk-close {
                width: auto;
            }
        }
    }
    .break-word {
        word-break: break-word;
    }
</style>
